document.addEventListener('DOMContentLoaded', () => {
    const clWrapper = document.querySelector('.cl-wrapper');
    if (!clWrapper) return;

    // 1. Populate Dropdowns Dynamically
    const populateDropdowns = () => {
        // Helper to mathematically build intervals and handle +/- signs safely
        const createOptions = (min, max, step, formatAsPower = true) => {
            const options = [];
            for (let i = min * 100; i <= max * 100; i += step * 100) {
                const val = i / 100;
                if (formatAsPower) {
                    // Add '+' sign to positive numbers, keep standard for negative/zero
                    options.push(val > 0 ? '+' + val.toFixed(2) : (val === 0 ? '0.00' : val.toFixed(2)));
                } else {
                    options.push(val.toString()); // Axis just needs the raw number
                }
            }
            return options;
        };

        const fillSelect = (ids, options, includeNone = false) => {
            ids.forEach(id => {
                const select = document.getElementById(id);
                if (!select) return;
                
                if (includeNone) {
                    const opt = document.createElement('option');
                    opt.value = 'None';
                    opt.textContent = 'None';
                    select.appendChild(opt);
                }
                
                options.forEach(val => {
                    const opt = document.createElement('option');
                    opt.value = val;
                    opt.textContent = val;
                    select.appendChild(opt);
                });
            });
        };

        // Build our specific clinical bounds
        const powers = createOptions(-10, 8, 0.25);
        const cyls = createOptions(-5, 5, 0.25);
        const axes = createOptions(0, 180, 10, false); // 0, 10, 20... 180
        const adds = createOptions(0.25, 3.00, 0.25);

        // Inject them into the Right (OD) and Left (OS) dropdowns
        fillSelect(['cl_od_pwr', 'cl_os_pwr'], powers);
        fillSelect(['cl_od_cyl', 'cl_os_cyl'], cyls, true); // Includes "None"
        fillSelect(['cl_od_axis', 'cl_os_axis'], axes, true); // Includes "None"
        fillSelect(['cl_od_add', 'cl_os_add'], adds, true); // Includes "None"
    };

    // Run the generator immediately
    populateDropdowns();

    // 2. Intercept standard Shopify Form Submissions AND Custom Buttons
    const openModalHandler = (e) => {

        const userCountry = clWrapper.dataset.country;
        
        // Only interrupt the flow if the user is in Canada
        if (userCountry === 'CA') {
            e.preventDefault();
            e.stopImmediatePropagation();
            
            const items = [];
            const selects = document.querySelectorAll('.quantity-dropdown');
            
            // Check if using the custom multi-variant grid
            if (selects.length > 0) {
                selects.forEach(select => {
                    const quantity = parseInt(select.value, 10);
                    const variantId = select.getAttribute('data-variant-id');
                    if (quantity > 0 && variantId) {
                        items.push({ id: parseInt(variantId), quantity });
                    }
                });
            } else {
                // Fallback: Standard Shopify variant selector
                const form = e.target.closest('form');
                if (form) {
                    const formData = new FormData(form);
                    items.push({ 
                        id: parseInt(formData.get('id')), 
                        quantity: parseInt(formData.get('quantity') || 1) 
                    });
                }
            }

            if (items.length === 0) return; // Exit if nothing is selected
            
            // Save the items globally and pop the modal open
            window.clCartItems = items;
            clWrapper.style.display = 'flex';
            document.body.style.overflow = 'hidden'; // Lock background scrolling
        }
    };

    // Hook into native Prestige Add To Cart forms
    const productForms = document.querySelectorAll('form[action$="/cart/add"]');
    productForms.forEach(form => form.addEventListener('submit', openModalHandler));

    // Fallback: Hook into custom Javascript buttons if they exist
    const customBtn = document.querySelector('#custom-add-to-cart');
    if (customBtn) {
        customBtn.addEventListener('click', openModalHandler);
    }

    // 2. Handle Modal Close
    const closeBtn = document.getElementById('cl_close_btn');
    closeBtn?.addEventListener('click', () => {
        clWrapper.style.display = 'none';
        document.body.style.overflow = 'auto';
    });

    // 3. Add To Cart Submission from INSIDE the modal
    const saveBtn = document.getElementById('cl_atc_btn');
    
    saveBtn?.addEventListener('click', async () => {
        saveBtn.textContent = "Adding to Cart...";
        saveBtn.style.pointerEvents = "none";
        saveBtn.style.opacity = "0.5";

        const payload = new FormData();
        const cartItems = window.clCartItems || [];
        const selectedClMethod = document.querySelector('.cl-opt-card.selected')?.dataset.rxMethod || 'send_later';

        cartItems.forEach((item, index) => {
            // Append standard Shopify requirements to ALL items
            payload.append(`items[${index}][id]`, item.id);
            payload.append(`items[${index}][quantity]`, item.quantity);
            
            if (item.selling_plan) {
                payload.append(`items[${index}][selling_plan]`, item.selling_plan);
            }

            // ONLY ATTACH PRESCRIPTION DATA TO THE VERY FIRST ITEM (Index 0)
            if (index === 0) {
                payload.append(`items[${index}][properties][Prescription Method]`, selectedClMethod);

                if (selectedClMethod === 'manual') {
                    // Array of all potential clinical inputs we added
                    const fields = [
                        { id: 'cl_od_pwr', name: 'OD Power' },
                        { id: 'cl_od_bc', name: 'OD BC' },
                        { id: 'cl_od_dia', name: 'OD DIA' },
                        { id: 'cl_od_cyl', name: 'OD CYL' },
                        { id: 'cl_od_axis', name: 'OD AXIS' },
                        { id: 'cl_od_add', name: 'OD ADD' },
                        { id: 'cl_os_pwr', name: 'OS Power' },
                        { id: 'cl_os_bc', name: 'OS BC' },
                        { id: 'cl_os_dia', name: 'OS DIA' },
                        { id: 'cl_os_cyl', name: 'OS CYL' },
                        { id: 'cl_os_axis', name: 'OS AXIS' },
                        { id: 'cl_os_add', name: 'OS ADD' }
                    ];

                    fields.forEach(field => {
                        const el = document.getElementById(field.id);
                        if (el && el.value) {
                            payload.append(`items[${index}][properties][${field.name}]`, el.value);
                        }
                    });
                    
                } else if (selectedClMethod === 'upload') {
                    const fileInput = document.getElementById('cl_file_input');
                    if (fileInput && fileInput.files.length > 0) {
                        payload.append(`items[${index}][properties][Prescription File]`, fileInput.files[0], fileInput.files[0].name);
                    }
                }
            }
        });

        try {
            await fetch('/cart/add.js', { method: 'POST', body: payload });
            window.location.href = '/cart'; // Redirect to cart when done
        } catch (err) {
            console.error("ATC Error:", err);
            saveBtn.textContent = "Error. Try again.";
            saveBtn.style.pointerEvents = "auto";
            saveBtn.style.opacity = "1";
        }
    });

    // 4. Handle Option Card Selection UX
    const optCards = document.querySelectorAll('.cl-opt-card');
    const atcBtn = document.getElementById('cl_atc_btn');

    optCards.forEach(card => {
        card.addEventListener('click', () => {
            optCards.forEach(c => {
                c.classList.remove('selected');
                c.style.borderColor = '#000';
                c.style.backgroundColor = '#fff';
            });
            
            card.classList.add('selected');
            card.style.borderColor = '#000';
            card.style.backgroundColor = '#f8f8f6';

            // Show/Hide inner containers based on selection
            const method = card.dataset.rxMethod;
            document.querySelector('.cl-manual-container').style.display = (method === 'manual') ? 'block' : 'none';
            document.querySelector('.cl-upload-container').style.display = (method === 'upload') ? 'block' : 'none';

            // Reveal ATC button once an option is clicked
            atcBtn.style.display = 'block';
        });
    });

    // NOTE: Keep your existing `populateRxDropdowns()` 2-column logic here at the bottom of the file
});